import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { 
  envAwarePost, 
  capitalize, 
  dateToAPIStandard,
  dateToYMD,
  ellipsis
} from '../../../util/util'
import { Form, Col, Row, Modal, Button, Spinner } from 'react-bootstrap';
import { Calendar, momentLocalizer } from 'react-big-calendar'
import './EventCalendar.css'
import moment from 'moment'
import { Link, useHistory } from 'react-router-dom';
import DatePicker from "react-datepicker"
import { selectTrainerParam } from '../../users/usersSlice'
import withDragAndDrop from "react-big-calendar/lib/addons/dragAndDrop";
import { 
  updateEvent, 
  getEventDetails, 
  triggerCalendarRefetch 
} from "../../../state/events.js"
import {
  updateNotesEditor,
  updateSelectedEventInfo,
  updateCopy,
  addEventForCopying,
} from '../../../state/events'
import CopyModal from '../CopyModal/CopyModal'
import useApiStatusDispatch from '../../../hooks/useApiStatusDispatch';
import { 
  deleteNote, 
  saveNote, 
  updateNote
} from '../../../state/clientNotesSlice';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import PendingSuccessButton from '../../PendingSuccessButton/PendingSuccessButton';
import { addEventToFavorites } from '../../eventsView/eventsViewSlice';
import { startDateRange } from '../../../util/datetime';

const DragAndDropCalendar = withDragAndDrop(Calendar)

const EventCalendar = ({noteModalShow, setNoteModalShow,setSelectEventShow}) => {
  const [eventList, setEventList] = useState([])
  const [formattedEventList, setFormattedEventList] = useState([])
  const [selectedDate, setSelectedDate] = useState('')
  const [clickedEvent, setClickedEvent] = useState({ empty: 'true' }) // for showing event details on calendar
  const [infoModalShow, setInfoModalShow] = useState(false)
  const [modalToggle, setModalToggle] = useState(false) // this is so if client clicks on same event, modal will still show

  const [isInfoLoading, setIsInfoLoading] = useState(false)
  const [isEventsLoading, setIsEventsLoading] = useState(false)
  const [calendarDate, setCalendarDate] = useState('')
  const [isEventBeingMoved, setIsEventBeingMoved] = useState(false)

  const [moreModalShow, setMoreModalShow] = useState(false)
  const [moreModalDate, setMoreModalDate] = useState('')
  const [moreModalEvents, setMoreModalEvents] = useState([])

  const localizer = momentLocalizer(moment)
  const [publishLoading, setPublishLoading] = useState(false);
  const [isDeletingEvent, setIsDeletingEvent] = useState(false)
  const [startOfMonth, setStartOfMonth] = useState('')

  // state for notes
  const [isCopyingNotes, setIsCopyingNotes] = useState(false)
  const [noteValue, setNoteValue] = useState("");
  const [isSavingNote, setIsSavingNote] = useState(false);
  const [editingNotes, setEditingNotes] = useState(false);
  const [noteDate, setNoteDate] = useState(new Date());


  const dispatch = useDispatch();
  const statusDispatch = useApiStatusDispatch();
  const isTrainer = useSelector(state => state.users.current_user.account_type) === 'trainer'
  const isTrainerOrGym = useSelector(state => (state.users.current_user.account_type === 'trainer' ||
    state.users.current_user.account_type === "gym"))

  const trainerParam = useSelector(selectTrainerParam)

  const copyModal = useSelector((state) => state.allEvents.copy)

  const calendarRefetch = useSelector(state => (state.allEvents.calendarRefetch))

  // trigger refetch of calendar using redux
  useEffect(()=>{
    if (calendarRefetch){
      fetchEvents();
      dispatch(triggerCalendarRefetch({refetch:false}))
    }
  },[calendarRefetch])

  const {
    selectedEventTypeCalendar: selectedType,
    selectedFilter: filter,
    selectedClient,
    isCalendarView
  } = useSelector(state => (state.allEvents.selectedEventInfo))

  useEffect(() => {
    if (!copyModal.show && copyModal.id) {
      dispatch(updateCopy({
        type: null,
        id: null,
        origin: null
      }))
      fetchEvents();
    }
  }, [copyModal.show])


  const currentUser = useSelector(state => state.users.current_user)

  const isClient = useSelector(state => state.users.current_user.account_type) === 'client'

  const hasPermission = (currentUser.edit_permissions.nutrition
    && currentUser.edit_permissions.task
    && currentUser.edit_permissions.workout
  ) === '1'

  const favoriteOrGymFilter = ['favorite', 'gym', 'gym_trainer'].includes(filter)

  //gets todays date then sets selectedDate 
  useEffect(() => {
    let today = new Date();
    setSelectedDate(startDateRange(today))
    let dd = today.getDate();
    let mm = today.getMonth() + 1;
    const yyyy = today.getFullYear();
    if (dd < 10) { dd = `0${dd}`; }
    if (mm < 10) { mm = `0${mm}`; }
    today = `${yyyy}-${mm}-${dd}`;
    setCalendarDate(moment(today).toDate())
    setStartOfMonth(`${yyyy}-${mm}-01`)
  }, [])

  // fetch all events within date range
  function fetchEvents() {
    let payload;
    payload = {
      action: 'getEventsInRange',
      event_type: selectedType.toLowerCase(),
      start_date: selectedDate,
      offset: 0,
      // 7 days into prev month
      // 31 to get all events in current month
      // 7 to get 7 days into next month
      // 7 + 31 + 7 = 45
      limit: 45,
    }
    if(!isClient){
      payload.client_id = selectedClient
    }
    envAwarePost('/api/events/api/', payload)
      .then(res => {
        // console.log('GET EVENTS: ', res.data)
        if (res.success === '1') {
          setEventList(res.data)
          setFormattedEventList(formatEventList(res.data))
        }
        setIsEventsLoading(false)
        setIsEventBeingMoved(false)
      })
  }
  
  //load in events then set eventlist
  useEffect(() => {
    if (selectedClient && selectedDate && selectedType && isCalendarView) {
      setIsEventsLoading(true)
      fetchEvents()
    }

  }, [selectedClient, selectedDate, selectedType, isCalendarView])

  // formats event data for the calendar component
  const formatEventList = (data) => {
    let formattedEvents = []
    let date;
    data.forEach(events => {
      date = events.date
      events.events.forEach(event => {
        formattedEvents.push({
          title: ellipsis(event.title,40),
          start: moment(date).toDate(),
          end: moment(date).toDate(),
          published: event.published,
          // allDay: true,
          resource: null,
          type: event.event_type,
          complete: event.complete,
          id: event.event_id,
        })
      })
    })
    return formattedEvents
  }

  //color codes the calendar event nodes depending on type
  let colorArray = ['#F0D19E', '#AAF0C6', '#B6F0EE', 'rgb(255 0 0 / 57%)']

  const eventStyleGetter = (event) => {
    let color;
    let border;
    if (!event.published) {
      border = colorArray[3];
    }
    switch (event.type) {
      case 'workout':
        color = colorArray[2]
        break
      case 'nutrition':
        color = colorArray[0]
        break
      case "task":
        color = colorArray[1]
        break
      case "note":
        color = "rgb(255 247 0)"
        break
      default:
        color = "#e9ecef"
    }
    let style = {
      backgroundColor: color,
      overflowWrap: 'break-word'

    }
    if (border) {
      style.border = `${moreModalShow ? "2px" : "2px"} solid ${border}`
    }

    return {
      style: style,
    }
  }

  //upon clicking an event node within calendar, loads event details
  //and sets state for loading spinner and eventdetails
  useEffect(() => {
    if (clickedEvent.empty !== 'true') {

      // notes have different modal then events
      if (clickedEvent.event_type === "note") {
        dispatch(updateNotesEditor({
          show:true,
          clientId:clickedEvent.client_id,
          id:clickedEvent.note_id,
          note:clickedEvent.note,
          date:clickedEvent.dateCreated
        }))
      } else {
        setInfoModalShow(true)
      }

    }
  }, [clickedEvent, modalToggle])

  

  //for calendar, updates the date on toolbar click
  const handleNavigation = (date, b, navButton) => {
    if (navButton === "PREV" || navButton === "NEXT") {
      setSelectedDate(startDateRange(date))
      setCalendarDate(moment(date).toDate())
    } else if (navButton === 'TODAY') {
      setSelectedDate(startDateRange(date))
      setCalendarDate(moment(date).toDate())
    }
  }


  let months = {
    'Jan': '01',
    'Feb': '02',
    'Mar': '03',
    'Apr': '04',
    'May': '05',
    'Jun': '06',
    'Jul': '07',
    'Aug': '08',
    'Sep': '09',
    'Oct': '10',
    'Nov': '11',
    'Dec': '12'
  }

  function handleMoveNote(event, start) {
    console.log('did this')
    setIsEventBeingMoved(true)
    dispatch(updateNote({
      update:{dateCreated: dateToAPIStandard(start)},
      skip_legacy_logic:1,
      note_id: event.id,
      id:event.id
    })).then(res => {
      fetchEvents()
    })
  }

  //for drag and drop
  const moveEvent = ({ event, start, end }) => {

    let eventStart = (start.toString()).split(" ")
    // console.log('EVENT: ', event)
    eventStart = `${eventStart[3]}-${months[eventStart[1]]}-${eventStart[2]}`

    // if its a note being moved then different process
    if (event.type === "note") {
      handleMoveNote(event, start);
      return;
    }

    //below is for workout/tasks/nutrition being moved
    let payload = {
      action: 'updateEvent',
      event_type: event.type,
      date: eventStart,
      event_id: (event.id).toString()
    }
    setIsEventBeingMoved(true)
    dispatch(getEventDetails({
      event_type: event.type,
      event_id: event.id
    })).then(() =>
      // dispatch(updateEvent(payload))
      envAwarePost('/api/events/api/', payload)
    ).then((res) => {
      fetchEvents();

    })
  }

  const handleShowMore = (e) => {
    setMoreModalShow(true)
    setMoreModalEvents(e)
    let date = (moment(e[0].start)).toString().split(' ').splice(0, 3).join(' ')
    setMoreModalDate(date)

  }


  let history = useHistory();
  function handleAddEventForCopying(payload) {
    dispatch(addEventForCopying(payload))
  }

  // publish a draft event
  function handlePublishEvent(publish) {
    if (!window.confirm(`Save as ${publish ? "published" : "draft"}?`)) { return}

    let eventType = clickedEvent.event_type
    setPublishLoading(true)
    setClickedEvent(prev => ({ ...prev, published: publish ? 1 : 0 }))
    statusDispatch(updateEvent({
      event_type: eventType,
      event_id: clickedEvent[`${eventType}_id`],
      published: publish ? "1" : "0"
    }), `${eventType}`, "update")
      .then((res) => {
        if (res.payload.success == "1") {
          // if successful then set localstate published value to 1
          // refetch calendar events
          fetchEvents()

        }
        setPublishLoading(false)
      })
  }

  // handle deleting a calendar event
  function handleDeleteEvent() {
    // if its a note then run handleDeleteNote
    if (clickedEvent.event_type === "note") {
      handleDeleteNote();
      return;
    }

    if (window.confirm("Are you sure you want to delete this event?")) {
      setIsDeletingEvent(true);
      envAwarePost('api/events/api/', {
        action: "deleteEvents",
        event_type: clickedEvent.event_type,
        event_ids: [clickedEvent.event_id]
      }).then(res => {
        fetchEvents()
        setIsDeletingEvent(false);
        setInfoModalShow(false);
      })
    }
  }

  //handle selecting a calendar event
  function handleSelectEvent(e) {
    eventList.forEach(listElement => {
      listElement.events.forEach(event => {
        if (event.event_id === e.id) {
          if (event.event_type === "note") {
            // if its a note set note and note created time local state
            setNoteValue(event.long_note)
            setNoteDate(new Date(event.dateCreated))
          } else {
            // if not a note prepare for copying
            handleAddEventForCopying(event)
          }
          setClickedEvent(event)
          setModalToggle(!modalToggle)
        }
      })
    })
  }

  //create a new note
  function createNote() {
    setIsSavingNote(true);
    statusDispatch(saveNote({
      dateCreated: dateToAPIStandard(noteDate),
      newNote: noteValue,
      client_id: selectedClient
    }), "note", "create").then(res => {
      fetchEvents();
      setIsSavingNote(false);
      clearNotesModal();
    })
  }

  // save an edited note
  function handleNoteSave() {
    setIsSavingNote(true);
    statusDispatch(updateNote({
      dateCreated: dateToAPIStandard(noteDate),
      note: noteValue,
      note_id: clickedEvent.note_id,
    }), "note", "update").then(res => {
      fetchEvents();
      setIsSavingNote(false);
      clearNotesModal();
    })
  }

  // delete an existing note
  const handleDeleteNote = () => {
    if (!window.confirm('Are you sure you want to delete this note?')) return
    setIsDeletingEvent(true);

    statusDispatch(deleteNote({
      client_id: selectedClient,
      note_id: clickedEvent.note_id,
    }), "note", "delete").then(res => {
      setIsDeletingEvent(false);
      fetchEvents();
      clearNotesModal();
    }
    )
  }

  //clear all notes modal data
  function clearNotesModal() {
    setNoteModalShow(false);
    setNoteValue("");
    setIsCopyingNotes(false);
    setEditingNotes(false)
  }


  const eventTypeToPrintSelector = type => (
    ['workout', 'task'].includes(type) ? `${capitalize(type)}s` : capitalize(type)
  )

  // render calendar event title and include event status icon 
  // (complete, open, not complete) 
  function handleRenderTitle(title) {
    return (
      <div class="">
        <div className="float-right ml-1">
          {title.complete === 1 ?
            // event marked completed
            <i className="fa fa-check text-success" /> :
            title.complete === 2 ?
              // event marked not completed
              <i className="fa fa-times text-danger" /> :
              title.complete === 0 ?
                // event open 
                <i className="fa fa-square text-secondary" /> :
                ""}
        </div>
        <div style={{ overflow: "hidden" }} className=""> {title.title} </div>
      </div>
    )
  }

  function handleCopyNotes() {
    setNoteModalShow(false);
    setEditingNotes(false);
    setIsCopyingNotes(true);
    setNoteModalShow(true);
  }

  return (
    // <div style={{ width: '95%', margin: '10px', marginBottom: '30px', height: '60%' }} className="calendarContainerDiv">
    <div style={{ height: '100%', background: '#fff' }} className="calendarContainerDiv" id="containerDiv">

      <div className="px-2 px-md-3">
        {selectedClient ?
            <div>
              <small className='p-form-label'>Select Date:</small>
              <DatePicker
                selected={calendarDate}
                onChange={(date) => { setSelectedDate(startDateRange(date)); setCalendarDate(moment(date).toDate()) }}
                dateFormat="EEE, MMM d, yyyy"
              />
            </div>
          : null}
      </div>


      {selectedClient ?
        <div style={{ position: "relative" }}>
          {(isEventsLoading || isEventBeingMoved) && <div>
            <Spinner
              style={{ position: "absolute", left: "50%", top: "50%" }}
              animation="border"
              variant="primary" />
          </div>}
          {isClient && !hasPermission ?
            <>
              <hr />
              <Calendar
                localizer={localizer}
                events={formattedEventList}
                startAccessor="start"
                endAccessor="end"
                date={calendarDate}
                onNavigate={handleNavigation}
                views={["month"]}
                onShowMore={(e) => handleShowMore(e)}
                eventPropGetter={eventStyleGetter}
                onSelectEvent={(e) => {
                  eventList.forEach(listElement => {
                    listElement.events.forEach(event => {
                      if (event.event_id === e.id) {
                        history.push(`/eventsView?display=${event.event_id}&selector=${eventTypeToPrintSelector(event.event_type)}&filter=client&client=${selectedClient}&origin=EventCalendar&view=list&${trainerParam}`)
                      }
                    })
                  })
                }}
              />
            </>
            :
            <>
              <div className="d-flex justify-content-between flex-wrap px-2 px-md-3">
                <div style={{ fontSize: "12.8px" }} className="mt-2">
                  <i className="fas fa-circle mr-1" style={{ color: 'rgb(103 209 206)' }}>
                  </i>Workouts | <i className="fas fa-circle mr-1" style={{ color: 'rgb(0 223 26)' }}>
                  </i>Tasks | <i className="fas fa-circle mr-1" style={{ color: 'rgb(255 156 33)' }}>
                  </i>Nutrition | <i className="fas fa-circle mr-1" style={{ color: "#ffeb3b" }}>
                  </i> Notes | <i className="far fa-circle mr-1" style={{ color: "rgba(255, 0, 0, 0.57)" }}></i> Draft
                </div>
                <div style={{ fontSize: "12.8px" }} className="mt-2">
                  <i className="fa fa-check mr-1 text-success" >
                  </i>Event Complete | <i className="fa fa-square mr-1 text-secondary" >
                  </i>Event Open | <i className="fa fa-times mr-1 text-danger" >
                  </i>Event Not Met

                </div>
              </div>
              <hr />
              <DragAndDropCalendar
                selectable
                localizer={localizer}
                events={formattedEventList}
                titleAccessor={handleRenderTitle}
                startAccessor="start"
                endAccessor="end"
                date={calendarDate}
                onEventDrop={moveEvent}
                onNavigate={handleNavigation}
                style={{ width: 'auto', zIndex: -1000, marginTop: '15px', marginBottom: '30px', marginRight: '0px', minHeight: "600px" }}
                views={["month"]}
                onShowMore={(e) => handleShowMore(e)}
                eventPropGetter={eventStyleGetter}
                onSelectEvent={(e) => {
                  handleSelectEvent(e);
                }}
                onSelectSlot={({ action, start, end }) => {
                  dispatch(updateSelectedEventInfo({selectedDate:dateToYMD(start)}))
                  setSelectEventShow(true)
                }}
              />
            </>
          }

          {/* show event info modal */}
          <Modal
            show={infoModalShow}
            onHide={() => { setInfoModalShow(false) }}
            style={{ display: 'flex !important', flexDirection: 'column', alignItems: 'center' }}
            centered
          >
            <Modal.Header className="w-100 " closeButton>
              <Modal.Title className="p-2 pl-5 w-100 text-center">
                {clickedEvent.title}
                <br />

                <Button
                  size="sm"
                  style={{ "fontSize": "14px", margin: "0px" }}
                  className=""
                  as={Link}
                  to={`/eventsView?display=${clickedEvent.event_id}&selector=${eventTypeToPrintSelector(clickedEvent.event_type)}&filter=client&client=${selectedClient}&origin=EventCalendar&view=list&${trainerParam}`}
                >
                  View Details
                </Button>
              </Modal.Title>
            </Modal.Header>

            <hr style={{ width: '100%', margin: '0px' }} />
            <Modal.Body style={{ width: '100%' }}>
              {isInfoLoading ? <Spinner animation="border" variant="primary" />
                :
                <>
                  <p style={{ whiteSpace: 'pre-wrap' }}>{clickedEvent.long_note}</p>
                  {Boolean(clickedEvent?.calendar_id)&&
                    <small>
                      <i className="fa fa-info-circle mr-1"/>
                      This is a training session to edit/delete please use the <Link to={`/scheduler?id=${clickedEvent.calendar_id}`}>Scheduler</Link>
                    </small>
                  }
                </>
              }
            </Modal.Body>
            {!Boolean(clickedEvent?.calendar_id)&&
              <Modal.Footer className="d-flex justify-content-between">
                {isInfoLoading ? null :
                  <>

                    {((!isClient || hasPermission) && !['gym', 'gym_trainer'].includes(filter) && !Boolean(clickedEvent?.calendar_id)) &&

                      < OverlayTrigger overlay={
                        <Tooltip>
                          Edit {capitalize(clickedEvent.event_type)}
                        </Tooltip>
                      }>
                        <Button
                          size="sm"
                          className=""
                          as={Link}
                          to={`/eventEditor/?event_id=${clickedEvent.event_id}&event_type=AddOrEdit&eventType=${capitalize(clickedEvent.event_type)}&client=${selectedClient}&origin=EventCalendar&${trainerParam}`}
                          variant="outline-primary"
                        >
                          <i className="fa fa-edit" />
                        </Button></OverlayTrigger>
                    }
                      < OverlayTrigger overlay={
                        <Tooltip>
                          {
                            clickedEvent.complete===1
                            ?`${capitalize(clickedEvent.event_type)} is already marked complete`
                            :`Mark ${capitalize(clickedEvent.event_type)} completed`
                          }
                        </Tooltip>
                      }>
                        <Button
                          onClick={()=>{
                              setClickedEvent({
                                ...clickedEvent,
                                complete:clickedEvent.complete^1
                              })
                              dispatch(updateEvent({
                                event_type:clickedEvent.event_type,
                                event_id:clickedEvent.event_id,
                                complete:clickedEvent.complete^1
                              })).then((res) => {
                                fetchEvents()
                              })
                          }}
                          size="sm"
                          className=""
                          variant={parseInt(clickedEvent.complete)===1?"primary":"outline-primary"}
                        >
                          <i className="fa fa-check" />
                        </Button></OverlayTrigger>
                    {(isTrainerOrGym || hasPermission) && < OverlayTrigger overlay={
                      <Tooltip>
                        Copy {capitalize(clickedEvent.event_type)}
                      </Tooltip>
                    }>
                      <Button
                        size="sm"
                        style={{ "fontSize": "14px", margin: "0px" }}
                        className="mx-1"
                        onClick={(e) => {
                          setInfoModalShow(false);
                          dispatch(updateCopy({
                            show: true,
                            type: clickedEvent.event_type,
                            id: clickedEvent.event_id,
                            origin: "EventCalendar",
                            defaultClientSelected: selectedClient
                          }))
                          e.currentTarget.blur();
                        }}
                        variant="outline-primary">
                        <i className="fas fa-copy"></i>
                      </Button>
                    </OverlayTrigger>
                    }
                    {!isClient && !favoriteOrGymFilter &&
                      <OverlayTrigger overlay={
                        <Tooltip>
                          Email {capitalize(clickedEvent.event_type)} to Client
                        </Tooltip>
                      }>
                        <PendingSuccessButton
                          onClick={({ onPending, onSuccess, onFailed }) => {
                            onPending()
                            envAwarePost('emailEvent/', {
                              //tell api endpoint to send a response
                              //rather than issuing a redirect
                              use_json_response: 1,
                              eventType: clickedEvent.event_type,
                              client_id: clickedEvent.client_id,
                              event_id: clickedEvent.event_id
                            }).then(({ success, message }) => {
                              if (success === '1') {
                                onSuccess()
                              } else {
                                onFailed()
                                window.alert(message)
                              }

                            })
                          }}
                          variant="outline-primary"
                        >
                          <i className="fas fa-at" />
                        </PendingSuccessButton>
                      </OverlayTrigger>
                    }

                    <OverlayTrigger overlay={
                      <Tooltip>
                        Print {capitalize(clickedEvent.event_type)}
                      </Tooltip>
                    }>
                      <Button
                        size="sm"
                        href={`/printEvents/?display=${clickedEvent.event_id}&selector=${eventTypeToPrintSelector(clickedEvent.event_type)}&client=${clickedEvent.client_id}`}
                        variant="outline-primary"
                        target=""
                        rel="noreferrer noopener"
                      >
                        <i className="fa fa-print" />
                      </Button>
                    </OverlayTrigger>

                    {isTrainerOrGym && <OverlayTrigger overlay={
                      <Tooltip>
                        Copy {capitalize(clickedEvent.event_type)} to Favorites
                      </Tooltip>
                    }>
                      <Button
                        size="sm"
                        onClick={(e) => {
                          if (!window.confirm('Copy event to favorites?')) return
                          statusDispatch(addEventToFavorites({
                            event_type: clickedEvent.event_type,
                            event_id: clickedEvent.event_id,
                          }), `${clickedEvent.event_type}`, "favorite")
                          e.currentTarget.blur();
                        }}
                        variant="outline-primary"
                      >
                        <i className="fa fa-star" />
                      </Button>
                    </OverlayTrigger>}

                    {!isClient && !favoriteOrGymFilter && <OverlayTrigger overlay={
                      <Tooltip>
                       {clickedEvent.published ? "Save as Draft" : "Publish"}
                      </Tooltip>
                    }>
                      <Button
                        disabled={publishLoading}
                        size="sm"
                        className=""
                        variant="outline-primary"
                        onClick={(e) => {
                          e.target.blur();
                          handlePublishEvent(!clickedEvent.published)
                        }}
                      >
                        {publishLoading ?
                          <Spinner size="sm" animation="border" /> :
                          !clickedEvent.published ? <i class="far fa-bookmark"></i> : <i class="fas fa-bookmark"></i>}
                      </Button>
                    </OverlayTrigger>}


                    {(isTrainerOrGym || hasPermission) && <OverlayTrigger overlay={
                      <Tooltip>
                        Delete {capitalize(clickedEvent.event_type)}
                      </Tooltip>
                    }>
                      <Button
                        size="sm"
                        disabled={isDeletingEvent}
                        className="ml-1"
                        onClick={handleDeleteEvent}

                        variant="outline-danger">
                        {isDeletingEvent ? <Spinner animation="border" variant="danger-outline" size="sm" /> : <i className="fa fa-trash" />}
                      </Button>
                    </OverlayTrigger>
                    }
                  </>
                }
              </Modal.Footer>
            }
          </Modal>

          <CopyModal />

        </div>
        : null}
      {/* show more modal */}
      <Modal
        show={moreModalShow}
        className='event-info-modal'
        onHide={() => setMoreModalShow(false)}
        style={{ display: 'flex !important', flexDirection: 'column', alignItems: 'center' }}
      >
        <Modal.Title>Events on {moreModalDate}:</Modal.Title>
        <hr style={{ width: '100%', margin: '0px' }} />
        <Modal.Body style={{ width: '100%' }}>
          <Row>
            <Col className='button-column'>
              {moreModalEvents.map((event) => {
                let style = eventStyleGetter(event)?.style;
                return (
                  <div 
                    style={{ 
                      background: style?.backgroundColor, 
                      border: style?.border 
                    }}
                    className="mt-1 p-1 moreModalShowEventStyle"

                    onClick={(e) => {
                      handleSelectEvent(event)
                      setMoreModalShow(false)
                    }}>
                    {handleRenderTitle(event)}
                  </div>
                )
              })}
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    </div >
  )
}

export default EventCalendar